<template>
  <div class="new-fund-buy-progress">
    <div class="top-header row">
      <div>认购流程</div>
      <div class="right row" @click="$goFundApp">
        <div class="more">了解更多</div>
        <img :src="RIGHT_ARROW" class="arrow"/>
      </div>
    </div>
    <!-- 进度条 -->
    <div v-if="!$isEmpty(buyProgressInfo)" class="progress row">
      <div v-for="(item, index) in buyProgressInfo" :key="index"
        :style="{flex: item.flex}"
        class="item">
        <div class="top">
          <div class="title">{{item.firstTitle}}</div>
          <div class="date">{{item.firstSubTitle}}</div>
        </div>
        <div :style="{...item.style, ...item.textStyle}" class="bottom"
          >{{item.text}}</div>
      </div>
    </div>
    <div class="bottom-tip">{{tipText}}</div>
  </div>
</template>

<script>
import { formatDate } from '@fund/basic-lib/dist/lib/date';

export default {

  name: 'new-fund-buy-progress',

  props: {
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      RIGHT_ARROW: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
    };
  },

  computed: {
    buyProgressInfo() {
      const { startTime, endTime } = this.basicInfo;
      const cycle = this.detailInfo?.newFundBuyProgressInfo?.cycle || '';
      const estabdate = this.detailInfo?.newFundBuyProgressInfo?.estabdate || '';
      return [
        {
          firstTitle: '募集开始',
          firstSubTitle: this.handleDate(startTime) || '--',
          text: '募集期',
          style: this.handleBackgroundColor(this.judgeTime(startTime) && !this.judgeTime(endTime)),
          flex: 7,
          textStyle: this.handleTextStyle(this.judgeTime(startTime) && !this.judgeTime(endTime)),
        },
        {
          firstTitle: '募集结束',
          firstSubTitle: this.handleDate(endTime) || '--',
          text: '备案期',
          style: this.handleBackgroundColor(this.judgeTime(endTime)),
          flex: 7,
          textStyle: this.handleTextStyle(this.judgeTime(endTime)),
        },
        {
          firstTitle: '产品成立',
          firstSubTitle: this.handleDate(estabdate) || '待定',
          text: this.$isEmpty(cycle) ? '封闭期' : `锁定期${cycle}`,
          style: this.handleBackgroundColor(this.judgeTime(estabdate)),
          flex: 12,
          textStyle: this.handleTextStyle(this.judgeTime(estabdate)),
        },
        {
          firstTitle: '开放卖出',
          firstSubTitle: this.$isEmpty(cycle) ? '待定' : `${cycle}后`,
          text: '存续期',
          style: this.handleBackgroundColor(false),
          flex: 7,
          textStyle: this.handleTextStyle(false),
        },
      ];
    },
    tipText() {
      const { endTime } = this.basicInfo;
      const estabdate = this.detailInfo?.newFundBuyProgressInfo?.estabdate;
      const DRAWCFMDATADAY = this.detailInfo?.newFundBuyProgressInfo?.DRAWCFMDATADAY;
      if (!this.judgeTime(endTime)) {
        return '以上日期仅供参考，请以基金公司公告为准；为避免基金认购提前结束，建议加入自选并及时关注募集结束时间。';
      }
      if (this.judgeTime(endTime) && !this.judgeTime(estabdate)) {
        return '新发基金一般会在募集结束后的10个交易日以内完成验资备案并成立；成立后的下一交易日，投资者可在持仓中查询到对应的基金份额。';
      }
      if (this.judgeTime(estabdate) && this.judgeTime(DRAWCFMDATADAY)) {
        return '新发基金一般会在募集结束后的10个交易日以内完成验资备案并成立；成立后的下一交易日，投资者可在持仓中查询到对应的基金份额。';
      }
      return '以上日期仅供参考，请以基金公司公告为准；为避免基金认购提前结束，建议加入自选并及时关注募集结束时间。';
    },
  },

  methods: {
    handleDate(value) {
      const date = new Date(value.replace(/-/g, '/'));
      const isInvalid = Number.isNaN(date.getTime());
      return !this.$isEmpty(value) && !isInvalid ? formatDate(new Date(value.replace(/-/g, '/')), 'yyyy-MM-dd')
        : '';
    },
    handleBackgroundColor(value) {
      return {
        backgroundColor: value ? '#FA5914' : '#FCD9CA',
      };
    },
    handleTextStyle(value) {
      return {
        textAlign: 'center',
        color: value ? '#ffffff' : '#000000',
      };
    },
    // 判断当前时间是否超过目标时间
    judgeTime(targetTime) {
      if (this.$isEmpty(targetTime)) return false;
      const now = new Date().getTime();
      return now - new Date(targetTime.replace(/-/g, '/')).getTime() >= 0;
    },
  },
};
</script>

<style lang="less" scoped>
.new-fund-buy-progress {
  width: 100%;
  background-color: #ffffff;
  margin-top: 24px;
  box-sizing: border-box;
  padding: 40px 24px;
  border-radius: 12px;
  .top-header {
    justify-content: space-between;
    font-size: 32px;
    color: #000000;
    font-weight: bold;
    .right {
      .more {
        font-size: 28px;
        color: #666666;
        font-weight: normal;
      }
      .arrow {
        width: 32px;
        height: 32px;
        margin-left: 8px;
      }
    }
  }
  .progress {
    margin-top: 56px;
    .item {
      border-left: 1px dashed #ccc;
      box-sizing: border-box;
      .top {
        padding-left: 4px;
        padding-top: 4px;
        padding-bottom: 32px;
        .title {
          font-family: PingFangSC-Semibold;
          font-size: 24px;
          color: #666666;
          font-weight: 600;
          white-space: nowrap;
        }
        .date {
          white-space: nowrap;
          margin-top: 15px;
          font-family: DINAlternate-Bold;
          font-size: 24px;
          line-height: 24px;
          font-weight: 700;
          color: #999999;
        }
      }
      .bottom {
        font-size: 28px;
      }
    }
  }
  .bottom-tip {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #666666;
    line-height: 36px;
    font-weight: 400;
    padding: 16px 24px;
    background: #F5F5F5;
    border-radius: 8px;
    margin-top: 32px;
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
</style>
